import { defaultValidators } from '$utils/formValidators'

export const mobilePhoneValidator = (insertedPhoneNumber: string) => {
  let errorText = ''
  if (insertedPhoneNumber.length !== 9) {
    errorText = 'Introduce un nº de teléfono de 9 cifras, sin prefijos ni otros caracteres. Ej. 600102030'
  }
  if (!defaultValidators.isValidPhoneNumber(insertedPhoneNumber)) {
    errorText = 'El teléfono móvil no es válido: tiene que ser una combinación de números'
  }
  if (!defaultValidators.required(insertedPhoneNumber)) {
    errorText = 'El número de teléfono es obligatorio'
  }

  return errorText
}



// WEBPACK FOOTER //
// ./src/views/PaymentDetails/OffSessionPayment/OffSessionCustomerPayment/CreditCardForm/CreditCardForm.validator.ts